(() => {
  const SURAH_NAMES = [
    "1: Al-Fātiḥa","2: Al-Baqarah","3: Āl-ʿImrān","4: An-Nisā’","5: Al-Mā’idah","6: Al-Anʿām","7: Al-Aʿrāf",
    "8: Al-Anfāl","9: At-Tawbah","10: Yūnus","11: Hūd","12: Yūsuf","13: Ar-Raʿd","14: Ibrāhīm","15: Al-Ḥijr",
    "16: An-Naḥl","17: Al-Isrā’","18: Al-Kahf","19: Maryam","20: Ṭā-Hā","21: Al-Anbiyā’","22: Al-Ḥajj",
    "23: Al-Mu’minūn","24: An-Nūr","25: Al-Furqān","26: Ash-Shuʿarā’","27: An-Naml","28: Al-Qaṣaṣ",
    "29: Al-ʿAnkabūt","30: Ar-Rūm","31: Luqmān","32: As-Sajdah","33: Al-Aḥzāb","34: Saba’","35: Fāṭir",
    "36: Yā-Sīn","37: As-Ṣāffāt","38: Ṣād","39: Az-Zumar","40: Ghāfir","41: Fuṣṣilat","42: Ash-Shūrā",
    "43: Az-Zukhruf","44: Ad-Dukhān","45: Al-Jāthiyah","46: Al-Aḥqāf","47: Muḥammad","48: Al-Fatḥ",
    "49: Al-Ḥujurāt","50: Qāf","51: Adh-Dhāriyāt","52: Aṭ-Ṭūr","53: An-Najm","54: Al-Qamar","55: Ar-Raḥmān",
    "56: Al-Wāqiʿah","57: Al-Ḥadīd","58: Al-Mujādalah","59: Al-Ḥashr","60: Al-Mumtaḥanah","61: Aṣ-Ṣaff",
    "62: Al-Jumuʿah","63: Al-Munāfiqūn","64: At-Taghābun","65: Aṭ-Ṭalāq","66: At-Taḥrīm","67: Al-Mulk",
    "68: Al-Qalam","69: Al-Ḥāqqah","70: Al-Maʿārij","71: Nūḥ","72: Al-Jinn","73: Al-Muzzammil","74: Al-Mudaththir",
    "75: Al-Qiyāmah","76: Al-Insān","77: Al-Mursalāt","78: An-Naba’","79: An-Nāziʿāt","80: ʿAbasa","81: At-Takwīr",
    "82: Al-Infitar","83: Al-Muṭaffifīn","84: Al-Inshiqāq","85: Al-Burūj","86: Aṭ-Ṭāriq","87: Al-Aʿlā",
    "88: Al-Ghāshiyah","89: Al-Fajr","90: Al-Balad","91: Ash-Shams","92: Al-Layl","93: Aḍ-Ḍuḥā","94: Ash-Sharḥ",
    "95: At-Tīn","96: Al-ʿAlaq","97: Al-Qadr","98: Al-Bayyinah","99: Az-Zalzalah","100: Al-ʿĀdiyāt",
    "101: Al-Qāriʿah","102: At-Takāthur","103: Al-ʿAṣr","104: Al-Humazah","105: Al-Fīl","106: Quraysh",
    "107: Al-Māʿūn","108: Al-Kawthar","109: Al-Kāfirūn","110: An-Naṣr","111: Al-Masad","112: Al-Ikhlāṣ",
    "113: Al-Falaq","114: An-Nās"
  ];

  const RECITER_SLUGS = {
    "Alafasy_128kbps": ["mishaari_raashid_al_3afaasee"],
    "Husary_128kbps":  ["mahmood_khaleel_al-husaree"]
    //"yasser_ad-dussary": ["yasser_ad-dussary"]
    // Variante "muallim" classique : ["husary_muallim"]
  };

  const pad3 = n => String(n).padStart(3, '0');
  const urlFor = (slug, s) => `https://download.quranicaudio.com/quran/${slug}/${pad3(s)}.mp3`;

  function init(root){
    const recSel   = root.querySelector('[data-role="reciter"]');
    const surahSel = root.querySelector('[data-role="surah"]');
    const audio    = root.querySelector('[data-role="audio"]');
    const status   = root.querySelector('[data-role="status"]');

    // Populate surahs
    SURAH_NAMES.forEach((name, i) => {
      const o = document.createElement('option');
      o.value = String(i + 1);
      o.textContent = name;
      surahSel.appendChild(o);
    });

    function setSourceWithFallback(slugs, s, k = 0){
      const slug = slugs[k];
      if(!slug){ status.textContent = "Audio indisponible pour ce récitateur."; return; }
      const url = urlFor(slug, s);
      audio.src = url;
      status.textContent = "";

      const onLoaded = () => {
        audio.removeEventListener('error', onError);
        status.textContent = "";
      };
      const onError = () => {
        audio.removeEventListener('loadedmetadata', onLoaded);
        setSourceWithFallback(slugs, s, k + 1);
      };
      audio.addEventListener('loadedmetadata', onLoaded, { once: true });
      audio.addEventListener('error', onError, { once: true });
    }

    function refresh(){
      const slugs = RECITER_SLUGS[recSel.value] || [];
      const s = parseInt(surahSel.value, 10);
      setSourceWithFallback(slugs, s, 0);
    }

    recSel.addEventListener('change', refresh);
    surahSel.addEventListener('change', refresh);

    // Defaults from data-attributes
    const defSurah = parseInt(root.getAttribute('data-default-surah') || '1', 10);
    const defRec   = root.getAttribute('data-default-reciter') || 'Alafasy_128kbps';
    if(RECITER_SLUGS[defRec]) recSel.value = defRec;
    surahSel.value = String(isNaN(defSurah) ? 1 : defSurah);

    refresh();
  }

  // Auto-init all instances
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-quran-player]').forEach(init);
  });
})();
